export default __webpack_public_path__ + "static/media/Resume2022.1b0c8f4b.pdf";